
import { serializeQuery } from '../Components/ReportCharts/ReportDataTransform';
import { BASE_PATH } from '../__mocks__/api';

export const downloadGroupLevelReports = async (requestObj: any, callback: Function) => {
    let fetchUrl = `${BASE_PATH}/counterreport`;

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: serializeQuery(requestObj)
    };

    fetch(fetchUrl, requestOptions).then(response => response.blob()).then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');

        a.href = url;
        a.download = "ScholasticOnline.xls";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  // afterwards we remove the element again   
        callback();
              
    }).catch(err => {
        callback();
    });
};
